import { extractErrorMessage } from './error.js';
import parseJSON from './parseJSON.js';
import { G as GetCmsBlocks } from '../GetCmsBlocks-WqKqizWw.js';
import { G as GetMenu } from '../GetMenu-ijOjaV0S.js';
import { p as publicQuery } from '../requestsCollection-A0HzS4ai.js';
import { GetPromotion } from '../services/graphql/promotion/index.js';
import get from 'lodash/get';
import { getCookie } from './cookies.js';
import { formatMenuUrls } from './menu.js';
import { l as COOKIE_PROMO_TAG } from '../cookies-VX_DpI1q.js';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-a4IKjS7g.js';
import '../serverErrors-O6unZmFR.js';
import './logger.js';
import './logToSlack.js';
import './logToRelic.js';
import 'react';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../services/auth/index.js';
import './currency.js';
import '../context/index.js';
import '../product-_pRduMz7.js';
import 'next/router';
import '../helpers-WYINLSKJ.js';
import './product.js';
import '../paths-ZKN3m62_.js';
import 'cookies-next';
import 'lodash';
import './fetchPolicyLookup.js';
import './isBot.js';
import '../types/index.js';
import '../checkout-Ee1eEXQH.js';
import '../menu-0TyOg98i.js';
import '../modal-6vnX5SO3.js';
import './category.js';
import '../GetCategoryBanner-HmQDOvcO.js';
import '../GetCategoryYmals--jYLM2RK.js';
import '../UrlResolver-OFrekbEP.js';

const serverRequest = async (apolloConfig, ctx) => {
    var _a, _b, _c;
    const { locale, siteName, employeePromoTag, currency } = ctx;
    const userAgent = (_a = ctx.req) === null || _a === void 0 ? void 0 : _a.headers['user-agent'];
    const promoTag = getCookie(COOKIE_PROMO_TAG, ctx);
    let navMenu = null;
    let footer = null;
    let promotion = null;
    const error = {
        message: null,
        statusCode: null,
    };
    try {
        const promotionReq = publicQuery(apolloConfig(), {
            query: GetPromotion,
        }, 'GetPromotion', ctx, true);
        const navMenuReq = publicQuery(apolloConfig(), {
            query: GetMenu,
            variables: {
                locale: ctx.locale,
                siteName,
            },
        }, 'GetMenu', ctx, false);
        const footerReq = publicQuery(apolloConfig(), {
            query: GetCmsBlocks,
            variables: {
                identifiers: ['footer'],
                locale,
            },
        }, 'GetCmsBlocks', ctx);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const promisesList = [navMenuReq, footerReq, promotionReq];
        const [navMenuRes, footerRes, promotionRes] = await Promise.all(promisesList);
        navMenu = formatMenuUrls(get(navMenuRes, ['data', 'scandiwebMenu'], null));
        footer = parseJSON(get(footerRes, ['data', 'cmsBlocks', 'items', 0, 'content'], null));
        const promoTagForSite = employeePromoTag || 'employeesite';
        promotion = {
            ...promotionRes.data.getpromo,
            employeeSite: promoTag === promoTagForSite || ((_b = ctx === null || ctx === void 0 ? void 0 : ctx.query) === null || _b === void 0 ? void 0 : _b['promo-tag']) === promoTagForSite,
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    catch (e) {
        error.message = extractErrorMessage(e);
        error.statusCode = (_c = e === null || e === void 0 ? void 0 : e.networkError) === null || _c === void 0 ? void 0 : _c.statusCode;
    }
    return {
        userAgent,
        navMenu,
        footer,
        promotion,
        currency,
        error,
    };
};

export { serverRequest };
//# sourceMappingURL=app.js.map
